import { App } from "antd";
import { useEffect } from "react";

type MessageMethod = "success" | "error" | "warning" | "info";
type MessageLike = Record<MessageMethod, (...args: unknown[]) => unknown>;

let runtimeMessage: MessageLike | null = null;

function emitMessage(method: MessageMethod, ...args: unknown[]) {
  if (!runtimeMessage) {
    return;
  }
  return runtimeMessage[method](...args);
}

export function notifyAdminWarning(...args: Parameters<MessageLike["warning"]>) {
  return emitMessage("warning", ...args);
}

export function notifyAdminError(...args: Parameters<MessageLike["error"]>) {
  return emitMessage("error", ...args);
}

export function AntdMessageBridge() {
  const app = App.useApp();

  useEffect(() => {
    runtimeMessage = app.message as unknown as MessageLike;
    return () => {
      if (runtimeMessage === app.message) {
        runtimeMessage = null;
      }
    };
  }, [app]);

  return null;
}
